'use strict';

var jsxRuntime = require('react/jsx-runtime');
var ProductIcon_constants = require('./ProductIcon.constants.js');

/**
 * 제품 아이콘을 표시하는 컴포넌트입니다.
 *
 * @param {Object} props - 컴포넌트 속성
 * @param {ProductIconName} props.name - 표시할 아이콘의 이름
 * @param {boolean} [props.disabled=false] - 아이콘의 비활성화 상태 여부
 * @param {'small' | 'medium' | 'large'} [props.size] - 아이콘의 크기. 지정하지 않으면 아이콘 이름에 따라 자동으로 결정됨
 * @returns {JSX.Element} 제품 아이콘 컴포넌트
 */ const ProductIcon = ({ name, disabled = false, size })=>{
    const generateIconSize = ()=>{
        if (size) return size;
        if (ProductIcon_constants.LargeProductIconNames.includes(name)) return 'large';
        if (ProductIcon_constants.MediumProductIconNames.includes(name)) return 'medium';
        if (ProductIcon_constants.SmallProductIconNames.includes(name)) return 'small';
    };
    const IconComponent = (props)=>{
        const Icon = ProductIcon_constants.productIcons.get(name);
        return Icon && jsxRuntime.jsx(Icon, Object.assign({}, props));
    };
    return jsxRuntime.jsx(IconComponent, {
        disabled: disabled,
        size: generateIconSize()
    });
};

module.exports = ProductIcon;
